export const hydrationDebugData = '__hydrationDebugData__';
